export default [
    "16 16",
    '<path fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" d="M13.625 13.625L10.9062 10.9062M7.375 5.5V9.25M5.5 7.375H9.25M12.375 7.375C12.375 10.1364 10.1364 12.375 7.375 12.375C4.61358 12.375 2.375 10.1364 2.375 7.375C2.375 4.61358 4.61358 2.375 7.375 2.375C10.1364 2.375 12.375 4.61358 12.375 7.375Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
]

